import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppMaterialModule } from './app-material/app-material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { IconService } from './icons-setting/Icons.service';
import { AuthModule } from "./auth/auth.module";
import { AppConfigService } from './app-config.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PatientListScreenComponent } from './patient-list-screen/patient-list-screen.component';
import { MainBoardModule } from './main-board/main-board.module';
import { AboutPatientScreenComponent } from './about-patient-screen/about-patient-screen.component';
import { PatientImagesScreenComponent } from './patient-images-screen/patient-images-screen.component';
import { ReportsScreenComponent } from './reports-screen/reports-screen.component';
import { PatientGalleryScreenComponent } from './patient-gallery-screen/patient-gallery-screen.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MatTabsModule } from '@angular/material/tabs';
import { CustomSnackbarComponent } from './common/custom-snackbar/custom-snackbar.component';
import { WebViewerFrameComponent } from './web-viewer-frame/web-viewer-frame.component';
import { ReportsScreenModule } from './reports-screen/reports-screen.module';
import { FileReaderService } from './file-reader.service';
import { UsersComponent } from './users/users.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UploadPatientMRNComponent } from './upload-patient-mrn/upload-patient-mrn.component';


export const appInitializerFn = (configService: AppConfigService) => {
  return () => configService.loadAppConfig();
};

@NgModule({
  declarations: [
    AppComponent,
    AboutPatientScreenComponent,
    PatientImagesScreenComponent,
    ReportsScreenComponent,
    PatientListScreenComponent,
    PatientGalleryScreenComponent,
    CustomSnackbarComponent,
    WebViewerFrameComponent,
    UsersComponent,
    UploadPatientMRNComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTabsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LazyLoadImageModule,
    HttpClientModule,
    AuthModule,
    AppMaterialModule,
    MainBoardModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [AppConfigService, FileReaderService, Title,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },
    IconService],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader { return new TranslateHttpLoader(http); }